import {
  AUTH_BASE_URL,
  COMPANIES_BASE_URL,
  CREDIT_BASE_URL,
  CURRENCY_WALLET_BALANCE,
  GET_CUSTOMER_AVAILABLE_LIMITS,
  GET_DOCUMENT_BY_ID,
  LAGER_CURRENT_USER,
  NOTIFICATIONS_BASE_URL,
  PAYABLES_BASE_URL,
  RECEIVABLES_BASE_URL,
  SUPPLIERS_BASE_URL,
  USER_INVITE,
  USER_REFRESH_TOKEN,
  WALLET_ACCOUNTS_BASE_URL,
  WALLET_BASE_URL,
} from '@treyd-io/shared/constants/endPoints';
import { DOCUMENTABLE_TYPE_MAP, OrderType } from './orders';

//#region Auth
export const GOOGLE_AUTH_LOGIN = `${AUTH_BASE_URL}/google/token/login/`;
export const GOOGLE_AUTH_SIGNUP = `${AUTH_BASE_URL}/google/merchant/token/sign-up/`;
export const USER_REFRESH_CLAIMS = `${AUTH_BASE_URL}/token/refresh-claims/`;
export const USER_LOG_IN = `${AUTH_BASE_URL}/token/obtain/`;
export const REVOKE_USER_IDENTITY = `${AUTH_BASE_URL}/revoke-identity/`;
export const USER_VALIDATE_EMAIL_VERIFICATION_TOKEN = `${AUTH_BASE_URL}/email/verify/`;
export const USER_ACCEPT_EMAIL_INVITE_TOKEN = `${AUTH_BASE_URL}/invitation/accept/`;
export const USER_ACCEPT_COMPANY_INVITATION = `${AUTH_BASE_URL}/invitation/acceptance/`;
export const USER_VERIFY_EMAIL_INVITE_TOKEN = `${AUTH_BASE_URL}/invitation/verify/`;
export const USER_EMAIL_VERIFICATION_RESEND = `${AUTH_BASE_URL}/resend-verify-email/`;
export const USER_EMAIL_CHANGE = `${AUTH_BASE_URL}/change-email/`;
export const USER_PASSWORD_CHANGE = `${AUTH_BASE_URL}/password/change/`;
export const USER_FORGOT_PASSWORD = `${AUTH_BASE_URL}/password/forget/request/`;
export const USER_RESET_PASSWORD = `${AUTH_BASE_URL}/password/forget/accept/`;
export const USER_VALIDATE_RESET_PASSWORD_TOKEN = `${AUTH_BASE_URL}/password/forget/verify/`;
export const USER_SIGN_UP = `${AUTH_BASE_URL}/sign-up/`;
export const SCRIVE_OTP = `${AUTH_BASE_URL}/scrive/otp/`;
export const RESEND_SCRIVE_OTP = `${AUTH_BASE_URL}/login/otp/resend`;
export const SCRIVE_OTP_SMS_VERIFY = (transactionId: string) =>
  `${AUTH_BASE_URL}/login/otp/${transactionId}/submit`;
export const SCRIVE_AUTH = `${AUTH_BASE_URL}/scrive${AUTH_BASE_URL}/`;
export const SCRIVE_OTP_SMS_SUBMIT = (transactionId: string) =>
  `${AUTH_BASE_URL}/scrive/transaction/${transactionId}/smsotp/submit`;
export const SCRIVE_AUTH_CHECKING = (transaction_id: number | string) =>
  `${AUTH_BASE_URL}/scrive/transaction/${transaction_id}`;
export const CANCEL_SCRIVE_TRANSACTION = (transactionId: number | string) =>
  `${AUTH_BASE_URL}/scrive/transaction/${transactionId}/cancel`;
export const ONFIDO_APPLICANT_SDK = `${AUTH_BASE_URL}/onfido/applicant/`;
export const ONFIDO_CREATING_CHECK = `${AUTH_BASE_URL}/onfido/check/`;
export const IMPERSONATE_USER = `${AUTH_BASE_URL}/impersonate/`;
//#endregion

//#region Companies
export const CREATE_COMPANY_ACCOUNT = `${COMPANIES_BASE_URL}/`;
export const COMPANY_INVOICING_CONTACT = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/invoicing-contact/`;
export const NEXT_REPAYMENT = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/next-repayment/`;
export const TOTAL_OUTSTANDING_AMOUNT = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/outstanding/`;
export const VALIDATE_KYC_DATA = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/validate_kyc_data/`;
//#endregion

//#region Documents
export const DOCUMENT_SIGN = (documentId: number) =>
  `/api/documents/${documentId}/sign/`;
export const DOCUMENT_CANCEL = (documentId: number) =>
  `/api/documents/${documentId}/cancel/`;
//#endregion

//#region Orders
export const ORDERS_SIGN = (documentableType: OrderType) =>
  `/api/${DOCUMENTABLE_TYPE_MAP[documentableType]}/sign/`;
export const ORDERS_SIGN_CANCEL = (documentableType: OrderType) =>
  `/api/${DOCUMENTABLE_TYPE_MAP[documentableType]}/cancel/`;
//#endregion

//#region Payables
export const CREATE_PAYABLE = `${PAYABLES_BASE_URL}/`;
export const PAYABLE_INVOICE = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/supplier-invoice/`;
export const PAYABLE_BULK_DELETE = `${PAYABLES_BASE_URL}/bulk-delete/`;
export const PAYABLE_INVOICE_CONTACT_LIST = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/invoice-contact-list/`;
export const PAYABLES_ERRORS_URL = (eventName: string) =>
  `${PAYABLES_BASE_URL}/sm_can_${eventName}/`;
export const PAYABLE_REQUEST_SIGNATURE = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/request-signature/`;
export const PAYABLE_NEXT_REPAYMENT = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/next-repayment/`;
export const PAYABLE_AI_RECOMMENDATIONS = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/get-recommendations/`;
export const PAYABLE_UPLOAD_QA_REPORTS_URL = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/qa-reports/`;
export const PAYABLE_DELETE_QA_REPORTS_URL = (
  payableId: number,
  qaReportId: number
) => `${PAYABLES_BASE_URL}/${payableId}/qa-reports/${qaReportId}/`;
export const PAYABLE_UPLOAD_SUPPORTING_FILES = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/supporting-files/`;
export const PAYABLE_DELETE_SUPPORTING_FILES = (
  payableId: number,
  fileId: number
) => `${PAYABLES_BASE_URL}/${payableId}/supporting-files/${fileId}/`;
export const PAYABLE_COMPANY_LIMIT_AFTER_ORDER = (orderId: number) =>
  `${PAYABLES_BASE_URL}/${orderId}/available-limits/`;
export const PAYABLE_COMPANY_LIMIT_AFTER_ORDERS = `${PAYABLES_BASE_URL}/available-limits/`;
export const BANK_AI_RECOMMENDATIONS = (orderId: number) =>
  `${PAYABLES_BASE_URL}/${orderId}/get-bank-account-recommendation/`;
//#endregion

//#region Receivables
export const CREATE_RECEIVABLE = `${RECEIVABLES_BASE_URL}/`;
export const RECEIVABLE_INVOICE = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/receivable-invoice/`;
export const RECEIVABLE_ALLOWED_CURRENCIES = `${RECEIVABLES_BASE_URL}/allowed-currencies/`;
export const RECEIVABLE_BULK_DELETE = `${RECEIVABLES_BASE_URL}/bulk-delete/`;
export const RECEIVABLE_INVOICE_CONTACT_LIST = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/invoice-contact-list/`;
export const RECEIVABLE_REQUEST_SIGNATURE = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/request-signature/`;
export const RECEIVABLE_NEXT_REPAYMENT = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/next-repayment/`;
export const RECEIVABLE_AI_RECOMMENDATIONS = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/get-recommendations/`;
export const RECEIVABLE_UPLOAD_SUPPORTING_FILES = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/supporting-files/`;
export const RECEIVABLE_DELETE_SUPPORTING_FILES = (
  receivableId: number,
  fileId: number
) => `${RECEIVABLES_BASE_URL}/${receivableId}/supporting-files/${fileId}/`;
export const RECEIVABLE_UPLOAD_PROOF_OF_DELIVERY_FILES = (
  receivableId: number
) => `${RECEIVABLES_BASE_URL}/${receivableId}/proof-of-delivery-files/`;
export const RECEIVABLES_ERRORS_URL = (eventName: string) =>
  `${RECEIVABLES_BASE_URL}/sm_can_${eventName}/`;
export const RECEIVABLE_COMPANY_LIMIT_AFTER_ORDERS = `${RECEIVABLES_BASE_URL}/available-limits/`;
//#endregion

//#region Notifications
export const DISMISS_BULK_UPDATES = `${NOTIFICATIONS_BASE_URL}/dismiss_bulk/`;
//#endregion

//#region Invoices
export const RESEND_INVOICE_BY_EMAIL = (invoiceId: number) =>
  `/api/order/invoices/${invoiceId}/resend/`;
export const INVOICE_SETTLEMENT_CLARIFICATION = (invoiceId: number) =>
  `/api/order/invoices/${invoiceId}/settlement-clarification-reason/`;
export const INVOICE_SUPPORTING_FILES = (invoiceId: number) =>
  `/api/order/invoices/${invoiceId}/supporting-files/`;
export const INVOICE_SUPPORTING_FILE = (invoiceId: number, fileId: number) =>
  `/api/order/invoices/${invoiceId}/supporting-files/${fileId}/`;
//#endregion

//#region ERPs
const ERPS_BASE_URL = '/api/erps';
export const ERP_INTEGRATIONS = `${ERPS_BASE_URL}/integrations/`;
export const CREATE_ERP_CONNECTION = `${ERPS_BASE_URL}/`;
export const REFRESH_ERP_CONNECTION = `${ERPS_BASE_URL}/refresh/`;
export const DISCONNECT_ERP_CONNECTION = `${ERPS_BASE_URL}/disconnect/`;
//#endregion

//#region Wallet
export const WALLET_DEPOSIT_ALLOWED_CURRENCIES = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/deposit_allowed_currencies/`;
export const WITHDRAW_WALLET_MONEY = `${WALLET_BASE_URL}/withdraw/`;
export const CANCEL_WITHDRAW_REQUEST = `${WALLET_BASE_URL}/withdraw/cancel/`;
export const SETTLE_INVOICE_WITH_WALLET = `${WALLET_BASE_URL}/settle/`;
export const CANCEL_SETTLEMENT_REQUEST = `${WALLET_BASE_URL}/settle/cancel/`;
export const INVOICE_SETTLEMENT_CALCULATION = (invoiceId: number) =>
  `${WALLET_BASE_URL}/invoice_settlement_calculation/${invoiceId}/`;
export const CONVERT_WALLET_MONEY = `${WALLET_BASE_URL}/convert/`;
export const CANCEL_CONVERT_REQUEST = `${WALLET_BASE_URL}/convert/cancel/`;
export const WALLET_FX_RATE = `${WALLET_BASE_URL}/fx_rates/current/`;
export const WALLET_CONVERT_BUY_ALLOWED_CURRENCIES = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/convert_buy_allowed_currencies/`;
//#endregion

//#region Suppliers
export const CREATE_SUPPLIER = `${SUPPLIERS_BASE_URL}/`;
export const UPDATE_SUPPLIER = (supplierId: number) =>
  `${SUPPLIERS_BASE_URL}/${supplierId}/`;
//#endregion
//#region Bank accounts
export const APPROVE_BANK_ACCOUNT = (bankAccountId: number) =>
  `/api/bank-accounts/${bankAccountId}/approve/`;
//#endregion

//#region Customers
const CUSTOMERS_BASE_URL = '/api/customer';
export const CREATE_CUSTOMER = `${CUSTOMERS_BASE_URL}/`;
export const SEARCH_CUSTOMER = `/api/risk/end-customers/search/`;
//#endregion

//#region Banking connections
const BANKING_CONNECTIONS_BASE_URL = '/api/banking-connections';
export const START_BANKING_CONNECTION = `${BANKING_CONNECTIONS_BASE_URL}/`;
export const REFRESH_BANKING_CONNECTION = `${BANKING_CONNECTIONS_BASE_URL}/refresh/`;
export const DISCONNECT_BANKING_CONNECTION = `${BANKING_CONNECTIONS_BASE_URL}/disconnect/`;
export const BANKING_CONNECTIONS_INTEGRATIONS = `${BANKING_CONNECTIONS_BASE_URL}/integrations/`;
//#endregion

//#region Credit
export const GET_ALL_CREDITS = (limit: number, page: number) =>
  `${CREDIT_BASE_URL}/?limit=${limit}&page=${page}`;
export const GET_AVAILABLE_CREDITS_AMOUNT = `${CREDIT_BASE_URL}/available/`;
//#endregion

//#region Consent
const CONSENT_BASE_URL = '/api/consent';
export const ACCEPT_TOS = `${CONSENT_BASE_URL}/tos/`;
export const ACCEPT_COMPANY_AGREEMENT = `${CONSENT_BASE_URL}/company_agreement/`;
//#endregion

export {
  CURRENCY_WALLET_BALANCE,
  GET_CUSTOMER_AVAILABLE_LIMITS,
  GET_DOCUMENT_BY_ID,
  LAGER_CURRENT_USER,
  USER_INVITE,
  USER_REFRESH_TOKEN,
};
